<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card class="elevation-1">
            <v-toolbar dark color="primary">
                <v-btn icon dark @click.native="handleModal">
                <v-icon>fas fa-times-circle</v-icon>
                </v-btn>
                <v-toolbar-title>Generar reporte de lista de precios</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col cols="12" class="mt-5">
                        <v-autocomplete :items="products" item-text="nombre" item-value="id"
                        prepend-inner-icon="fas fa-cube" hint="Selecciona un producto."
                        v-model="productId" label="Productos" required outlined clearable >
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                        <v-autocomplete :items="clients" item-text="nombreComercial" item-value="idCliente"
                        prepend-inner-icon="fas fa-users" hint="Selecciona un cliente opcional."
                        v-model="clientId" label="Clientes" required outlined clearable>
                        </v-autocomplete>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-3" dark class="btn text-white" @click.native.prevent="downloadExcelProductPrice">
                    <v-icon left>fas fa-file-excel</v-icon> Descargar Excel
                </v-btn>
                <v-btn color="blue darken-4" dark class="btn text-white" @click.prevent="exportPriceList">
                    <v-icon left>fas fa-file-pdf</v-icon>Descargar pdf
                </v-btn>
            </v-card-actions>
        </v-card>
        <PreviewPDF :pdfSource="pdfSource" :pdfBlob="pdfBlob"
        title-pdf="Reporte de lista de precios"
        :handlePdfModal="handlePdfModal" :dialog="showPdf" v-if="showPdf">
        </PreviewPDF>
    </v-dialog>
</template>
<script>
import PreviewPDF from '@/components/shared/PreviewPDF.vue';
import { showErrorAlert, showInfoAlert, showSuccessAlert } from '@/helpers/swalHelper';
import ProductoListaPrecioDataService from '@/service/producto/ProductoListaPrecioDataService';
import { getToday } from '@/utils/DateUtil';

export default {
    name: 'ExcelExportetProductPrice',
    props: {
        dialog: { type: Boolean, default: false },
        handleModal: { type: Function },
        products: { type: Array, required: true, default: [] },
        clients: { type: Array, required: true, default: [] },
        isAdmin: { type: Boolean, default: false }
    },
    components: { PreviewPDF },
    data() {
        return {
            productId: null,
            clientId: null,
            showDetail: false,
            // to export report by pdf.
            pdfBlob: '',
            pdfSource: null,
            showPdf: false,
        }
    },
    methods: {
        downloadExcelProductPrice() {
            this.$swal.fire({
                title: 'Quieres continuar con la descarga del reporte de lista de precios?',
                text: "El tiempo de descarga puede variar dependiendo de la cantidad de registros!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, descargar!',
                cancelButtonText: 'Cancelar',
                showLoaderOnConfirm: true,
                preConfirm: async () => {
                    const params = { productId: this.productId, clientId: this.clientId };
                    try {
                        return await ProductoListaPrecioDataService.exportProductPriceByDateAndClientId(params);
                    } catch (error) {
                        this.$swal.showValidationMessage(`Petición fallida: ${error}`);                        
                    }
                },
                allowOutsideClick: () => !this.$swal.isLoading()
            }).then( result => {
                if (result.isConfirmed) {
                    if(result.value.status === 204) {
                        showInfoAlert({ title: 'Reporte', text: 'No hay registros para su descarga' });
                    } else {
                        const { data } = result.value;
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `reporte-lista-de-precios_${getToday}.xlsx`);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        showSuccessAlert({ title: 'Reporte de lista', text: 'Reporte descargado correctamente' });
                    }
                }
            }).catch(err => {
                showErrorAlert({ title: 'Error', text: 'Error al consultar los datos '+ err });
            });
        },
        exportPriceList(){
            const params = { productId: this.productId, clientId: this.clientId };
            ProductoListaPrecioDataService.printPriceList(params)
            .then( response => {
                if(response.status == 204) {
                    showInfoAlert({ title: 'Reporte de lista de precios', text: 'No hay registros para visualizar'});
                    return
                }
                this.pdfBlob = new Blob([response.data], { type: 'application/pdf' })
                this.pdfSource = URL.createObjectURL(this.pdfBlob)
                this.showPdf = true
            }).catch( error => {
                showErrorAlert({ title: 'Error al generar el reporte', text: error.response.data });
            });
        },
        handlePdfModal(){
            this.showPdf = !this.showPdf
            this.cleanupPdf()
        },
        cleanupPdf(){
            if(this.pdfSource){
                URL.revokeObjectURL(this.pdfSource)
                this.pdfSource = null
            }
            this.pdfBlob = null
        }
    }
}
</script>